import React, { useState ,useEffect} from 'react';
import DrcViewer from '../DRC/DrcViewer';
import ReportBugandImprovement from './ReportBugandImprovement/ReportBugandImprovement';
import { CommentDataProvider } from './ReportBugandImprovement/CommentDataContext';
import './leftbar.css';
import CircleIcon from '@mui/icons-material/Circle';
import SquareIcon from '@mui/icons-material/Square';
import ChangeHistoryIcon from '@mui/icons-material/ChangeHistory';
import PopupMessage from './PopupMessage';
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsIcon from '@mui/icons-material/Settings';
import SchemaIcon from '@mui/icons-material/Schema';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import StraightenIcon from '@mui/icons-material/Straighten';
import ChatIcon from '@mui/icons-material/Chat';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import SearchIcon  from '@mui/icons-material/Search';
import SettingsPopup from './SettingsPopup';
import PolylineIcon from '@mui/icons-material/Polyline';
import ToolManager from '../libraries/ToolManager';
import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import ChatViewer from '../botui/ChatViewer.jsx';
import ChromeReaderModeIcon from '@mui/icons-material/ChromeReaderMode';
import { ImportExportOutlined } from '@mui/icons-material';
import ParametricSidePanel from '../perametric/ParametricSidePanel';
import { Tooltip } from '@mui/material';
import HighlightIcon from '@mui/icons-material/Highlight';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';


const LeftBar = ({ onIconClick }) => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
   const [isDrcViewerOpen, setIsDrcViewerOpen] = useState(false);
   const [bugsection, setBugsection] = useState(false);
   const [popupMessage, setPopupMessage] = useState('');
   const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isShapesDropdownOpen, setIsShapesDropdownOpen] = useState(false); // State to toggle dropdown visibility
  const [selectedShape, setSelectedShape] = useState('rectangle'); // State to track selected shape
  const [isBotOpen, setIsBotOpen] = useState(false);
  const [showParamPanel, setShowParamPanel] = useState(false); 
  const [parametricAiRequestId, setParametricAiRequestId] = useState(0);

  const shapes = [
    { id: "rectangle", icon: <SquareIcon fontSize="small" />, label: 'Rectangle' },
    // { id: "circle", icon: <CircleIcon fontSize="small" />, label: 'Circle' },
    // { id: "triangle", icon: <ChangeHistoryIcon fontSize="small" />, label: 'Triangle' },
    { id: "polygon", icon: <PolylineIcon fontSize="small" />, label: 'Polygon' },
  ];


  useEffect(() => {
      const open = () => setIsDrcViewerOpen(true);
      window.addEventListener("open-drc-viewer", open);
      window.addEventListener("open-right-panel", open);
      window.addEventListener("drc-file-loaded", open);
      return () => {
        window.removeEventListener("open-drc-viewer", open);
        window.removeEventListener("open-right-panel", open);
        window.removeEventListener("drc-file-loaded", open);
      };
    }, []);

  // helper function
const ensureCellOrGds = () => {
  const hasCreated = window.layoutEngine.getCells().length > 0;
  const hasUploaded = window.layoutEngine.getUploadedCells().length > 0;
  const activeCell = window.layoutEngine.getActiveCellName();

  // ✅ If at least one created/uploaded cell exists, allow drawing
  if (!hasCreated && !hasUploaded) {
    setPopupMessage("⚠️ Please create a cell or upload GDS before creating shapes/labels/rulers.");
    setIsPopupOpen(true);
    return false;
  }

  // Optional: If you want to force an active cell
  if (!activeCell) {
    console.warn("ℹ️ No active cell selected, using first created cell by default.");
    const firstCell = hasCreated
      ? window.layoutEngine.getCells()[0].name
      : window.layoutEngine.getUploadedCells()[0].name;
    window.layoutEngine.showAsTop(firstCell); // set it active
  }

  return true;
};


  const handletag = (tagId) => {
    if (!ensureCellOrGds()) return; // Check before proceeding
    ToolManager.setTool(tagId);
    window.dispatchEvent(new CustomEvent("tool-changed", { detail: tagId }));
  };
  const handleSelectShape = (shapeId) => {
    if (!ensureCellOrGds()) return; // Check before proceeding
      ToolManager.setTool(shapeId);
    setSelectedShape(shapeId); // Update the selected shape
    setIsShapesDropdownOpen(false); // Close the dropdown
    window.dispatchEvent(new CustomEvent("tool-changed", { detail: shapeId })); // shiv code
    };
    const toggleDrcViewer = () => {
    setIsDrcViewerOpen(!isDrcViewerOpen);
  };

  // comunication window handler
    const handleCommunicationWindow = () => {
      const currentTool = ToolManager.getCurrentTool();
      if (currentTool === "bug&imp") {
        ToolManager.setTool("select");
        window.dispatchEvent(
          new CustomEvent("tool-changed", { detail: "select" })
        );
        setBugsection(false);
        return;
      } else {
        ToolManager.setTool("bug&imp");
        window.dispatchEvent(
          new CustomEvent("tool-changed", { detail: "bug&imp" })
        );
        setBugsection(true);
      }
    };
    useEffect(() => {
      const onToolChanged = (e) => {
        const tool = e?.detail || ToolManager.getCurrentTool();
        const isBug = tool === "bug&imp";
        setBugsection(isBug);
        if (isBug) {
          window.canvasEngine?.FeatureRenderer?.emitSceneUpdate?.();
        }
        if (["rectangle", "circle", "triangle", "polygon"].includes(tool)) {
          setSelectedShape(tool);
          setIsShapesDropdownOpen(false);
        }
      };
  
      window.addEventListener("tool-changed", onToolChanged);
      onToolChanged({ detail: ToolManager.getCurrentTool() });
  
      return () => window.removeEventListener("tool-changed", onToolChanged);
    }, [bugsection]);


  return (
    <>
      <div className="left-bar">
        <div className="icon-container">
          {/* Shapes Dropdown */}
          <div className="dropdown-container">
            <Tooltip title="Create Shapes" placement="right">
            <div
              className="dropdown-trigger"
              onClick={() => setIsShapesDropdownOpen(!isShapesDropdownOpen)}
            >
              {shapes.find((shape) => shape.id === selectedShape)?.icon} {/* Display selected icon */}
            </div>
            </Tooltip>
            {isShapesDropdownOpen && (
              <div className="dropdown-menu">
                {shapes.map((shape) => (
                  <div
                    key={shape.id}
                    className={`dropdown-item ${
                      selectedShape === shape.id ? 'selected' : ''
                    }`}
                    onClick={() => handleSelectShape(shape.id)}
                  >
                    {shape.icon} {shape.label}
                  </div>
                ))}
              </div>
            )}
          </div>

          <Tooltip title="Create Label" placement='right'>  
          <LocalOfferIcon
            fontSize="small"
            className="icon"
            onClick={() => handletag("label")}
          />
          </Tooltip>
          <Tooltip title="Ruler" placement='right'>
          <StraightenIcon fontSize="small" className="icon" onClick={()=>handletag("ruler")} />
          </Tooltip>

          <Tooltip title="Reset Ruler" placement='right'>
            <FormatPaintIcon
            fontSize="small"
            onClick={() => {
              if (!ensureCellOrGds()) return;
              window.canvasEngine.rulerHandler.resetCurrentCellRulers();
            }}
            className="icon"
          />
          </Tooltip>

          <Tooltip title="Parametric Controls" placement='right'>
            <ChromeReaderModeIcon
              fontSize="small"
              className="icon"
              onClick={() => setShowParamPanel(!showParamPanel)}
            />
          </Tooltip>

          <Tooltip title="Parametric AI Agent" placement='right'>
            <AutoAwesomeIcon
              fontSize="small"
              className="icon"
              onClick={() => {
                setShowParamPanel(true);
                setParametricAiRequestId((current) => current + 1);
              }}
            />
          </Tooltip>

          
          {/* <Inventory2Icon fontSize="small" className="icon" />
          <SchemaIcon fontSize="small" className="icon" /> */}

          <Tooltip title="Comment Section" placement='right'>
          <ChatIcon
            fontSize="small"
            className="icon"
            onClick={handleCommunicationWindow}
          />
          </Tooltip>

          <Tooltip title="DRC Explorer" placement='right'>
          <HighlightIcon fontSize="small"  className="icon" onClick={toggleDrcViewer} />
          </Tooltip>

          <Tooltip title="AI ChatBot" placement='right'>
          <SmartToyIcon
                      fontSize="small"
                      className="icon"
                      onClick={() => setIsBotOpen((v) => !v)}   // same as DRC pattern
                    />
          </Tooltip>
        </div>
        <div className="bottom-icon">
          <Tooltip title="Settings" placement='right'>
            <SettingsIcon fontSize="small" titleAccess="Settings" className="icon" onClick={() => setIsSettingsOpen(true)}/>
          </Tooltip>
      </div>
      </div>
     { bugsection && 
      <CommentDataProvider>
      <ReportBugandImprovement setBugsection={setBugsection}/>
        </CommentDataProvider>}
      <div style={{ display: isDrcViewerOpen ? 'block' : 'none' }}>
        <DrcViewer onClose={toggleDrcViewer} />
      </div>
      <div style={{ display: isBotOpen ? 'block' : 'none' }}>
              <ChatViewer onClose={() => setIsBotOpen(false)} />
            </div>
      <SettingsPopup isOpen={isSettingsOpen} onClose={() => setIsSettingsOpen(false)} />
      <ParametricSidePanel
        isOpen={showParamPanel}
        onClose={() => setShowParamPanel(false)}
        aiLaunchRequestId={parametricAiRequestId}
      />

        <PopupMessage
        isOpen={isPopupOpen}
        message={popupMessage}
        onClose={() => setIsPopupOpen(false)}
      />
    </>
  );
};

export default LeftBar;
